import vuex from 'vuex';
import Vue from 'vue';

Vue.use(vuex);

let store = new vuex.Store({
    state : {
        flag : false
    },
    mutations : {
        is(state,flag){
            if(flag == state.flag){
                return;
            }
            state.flag = flag
        }
    },
    getters : {
        getFlag(state){
            return state.flag;
        }
    },
    actions:{
        isTarset(store,flag){
            if(store.state.flag == flag){
                return;
            }
            store.commit('is',flag);
        }
    },
    modules : {
        
    }
});


export default store;